import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { markEditSectionAsRead } from 'AppSrc/core/actions/actions-edit-form';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import ReactRouterPropTypes from 'react-router-prop-types';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
// import { ExpandCollapseAll } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/expand-collapse-all';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/section-summary.css';
import { fetchNotificationComms, fetchNotificationCommsDetailed } from '../../crq/crq-list-actions';
import { ViewCommsSummaryDetailed } from './view-crq-comms-summary-detailed';


class ViewCrqCommsSummary extends React.Component {
  constructor(props) {
    super(props);
    const openStatuses = this.getInitialOpenStatuses();
    this.state = {
      openStatuses,
    };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.generateOpenStatusesArray = this.generateOpenStatusesArray.bind(this);
    this.getInitialOpenStatuses = this.getInitialOpenStatuses.bind(this);
    this.navigateToSection = this.navigateToSection.bind(this);
    this.getSectionsToShow = this.getSectionsToShow.bind(this);
  }

  componentDidMount() {
    const params = {
      network: 'fixed',
      crqId: this.props.crqId,
      type: 'SUMMARY',
    };
    this.props.notificationCommsAPI(params).then((results) => {
    }).catch((error) => {
      console.error(error);
      // redirect to the page not found screen
      this.props.errorAlert({
        errorTitle: 'Failed to load CRQ',
        errorText: 'Unable to load CRQ data. Please refresh the page and try again.',
      });
    });
  }


  getInitialOpenStatuses() {

    const {
      formData,
      viewCrqPowers,
    } = this.props;

    const {
      canViewErrors,
    } = viewCrqPowers;

    const {
      formSectionsByDisplayOrder,
      summaryErrors,
    } = formData;

    // we don't always show errors
    const hasViewableErrors = canViewErrors && summaryErrors;

    // if it's cancelled, we don't show errors
    if (!hasViewableErrors) {
      return this.generateOpenStatusesArray(false);
    }

    return formSectionsByDisplayOrder.map((sectionId) => {
      const sectionErrors = summaryErrors[sectionId];
      const hasError = sectionErrors && Object.keys(sectionErrors).length > 0;
      return hasError;
    });
  }

  // get the list of form sections to display
  getSectionsToShow() {
    const { formData } = this.props;
    return formData.formSectionsByDisplayOrder;
  }

  // Generate array representing the open status of each section
  // sections[3] is open if openStatuses[3] == true
  // initialised all elements with value of `areOpen`
  generateOpenStatusesArray(areOpen) {
    const numSections = this.getSectionsToShow().length;
    return Array(numSections).fill(areOpen);
  }

  navigateToSection(options) {
    const {
      history,
      crqId,
      network,
    } = this.props;
    const {
      navToSectionId,
    } = options;

    this.props.markEditSectionAsRead(crqId, navToSectionId);
    window.localStorage.setItem('validation', true);

    history.push(`/crq/edit/${network}/${crqId}/${navToSectionId}`);
  }

  expandAll() {
    this.setState({
      openStatuses: this.generateOpenStatusesArray(true),
    });
  }

  collapseAll() {
    this.setState({
      openStatuses: this.generateOpenStatusesArray(false),
    });
  }

  toggleOpen(sectionIndex, uid) {
    const {
      crqId,
    } = this.props;
    const params = {
      network: 'fixed',
      type: 'DETAILED',
      guid: uid,
    };
    this.props.notificationCommsAPIDetailed(params).then((results) => {
      console.log('notification summary response', results);
    }).catch((error) => {
      console.error(error);
      console.log('notification summary error', error);
      // redirect to the page not found screen
      this.props.errorAlert({
        errorTitle: 'Failed to load CRQ',
        errorText: 'Unable to load CRQ data. Please refresh the page and try again.',
      });
    });

    const sectionIds = this.getSectionsToShow();
    const sectionId = sectionIds[sectionIndex];
    this.props.markEditSectionAsRead(crqId, sectionId);

    this.setState((prevState) => {
      // toggle the boolean value of openStatuses[sectionIndex]
      const openStatuses = prevState.openStatuses.map(
        (open, index) => (index === sectionIndex ? !open : open),
      );
      return ({
        openStatuses,
      });
    });
  }

  render() {
    const {
      formData,
      network,
      // summarySectionsRead,
      viewCrqPowers,
      viewType,
      hasErrors,
      notificationCommsSummaryData,
      notificationCommsSummaryDataDetailed,
      isEmpty,
      isEmptyComms,
    } = this.props;
    // const {
    //   dataByFormSectionId,
    //   summaryErrors,
    // } = formData;
    const {
      canEditForm,
      // canViewSectionsRead,
    } = viewCrqPowers;

    const { openStatuses } = this.state;
    // const allExpanded = openStatuses.every((open, index) => index === 0 || open);
    const navigateToSection = canEditForm ? this.navigateToSection : null;
    // disables the submit button if the form is not readyToSubmit... Also does a hack to stop mobile submission!
    // expand all prevents the user from knowing if they have read something so we disable it if
    // the user is expected to read each sectio
    // const showExpandAll = !canViewSectionsRead;

    return (
      <ViewCommsSummaryDetailed
        openStatuses={openStatuses}
        toggleOpen={this.toggleOpen}
        navigateToSection={navigateToSection}
        viewType={viewType}
        hasErrors={hasErrors}
        selectedNetwork={network}
        formData={formData}
        isEmpty={isEmpty}
        isEmptyComms={isEmptyComms}
        notificationCommsSummaryData={notificationCommsSummaryData}
        notificationCommsSummaryDataDetailed={notificationCommsSummaryDataDetailed}
      />
    );
  }
}

ViewCrqCommsSummary.propTypes = {
  crqId: PropTypes.string,
  network: PropTypes.string,
  formData: formDataShape,
  history: ReactRouterPropTypes.history,
  // summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  markEditSectionAsRead: PropTypes.func,
  viewCrqPowers: PropTypes.objectOf(PropTypes.bool),
  viewType: PropTypes.string,
  hasErrors: PropTypes.bool,
  notificationCommsSummaryData: PropTypes.arrayOf(PropTypes.object),
  notificationCommsSummaryDataDetailed: PropTypes.arrayOf(PropTypes.object),
  isEmpty: PropTypes.bool,
  notificationCommsAPIDetailed: PropTypes.func,
  errorAlert: PropTypes.func,
  notificationCommsAPI: PropTypes.func,
  isEmptyComms: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  notificationCommsSummaryDataDetailed: state && state.crqList && state.crqList.notificationCommsListDetailed && state.crqList.notificationCommsListDetailed,
  isEmpty: state && state.crqList && state.crqList.isEmpty && state.crqList.isEmpty,
  notificationCommsSummaryData: state && state.crqList && state.crqList.notificationCommsList && state.crqList.notificationCommsList,
  isEmptyComms: state && state.crqList && state.crqList.isEmpty && state.crqList.isEmptyComms,
});


const mapDispatchToProps = (dispatch, ownProps) => ({
  markEditSectionAsRead: (crqId, sectionId) => {
    const {
      viewCrqPowers,
    } = ownProps;

    // we only want this to fire if the user can view sections read
    const {
      canViewSectionsRead,
    } = viewCrqPowers;

    if (canViewSectionsRead) {
      dispatch(markEditSectionAsRead(crqId, sectionId));
    }
    return null;
  },
  notificationCommsAPIDetailed: (params) => dispatch(fetchNotificationCommsDetailed(params)),
  notificationCommsAPI: (params) => dispatch(fetchNotificationComms(params)),
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
});



ViewCrqCommsSummary = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewCrqCommsSummary);




export { ViewCrqCommsSummary };



